import { render, staticRenderFns } from "./supplier_information.vue?vue&type=template&id=5bf8d7b9&scoped=true&"
import script from "./supplier_information.vue?vue&type=script&lang=js&"
export * from "./supplier_information.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf8d7b9",
  null
  
)

export default component.exports